module.exports = __webpack_public_path__ + "img/lighthouse-vert.c1d72541.png";